import PropTypes from 'prop-types'
import {TabPanelContainer} from './FilterTabPanelStyles'

/**
 * FilterTabPanel Component
 *
 * Container for tab panel content. Shows/hides based on current tab selection.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to display in the tab panel
 * @param {number} props.value - Current active tab index
 * @param {number} props.index - This panel's tab index
 * @param {string} props.categoryId - Category identifier
 */
const FilterTabPanel = ({children, value, index, categoryId}) => {
  const isVisible = value === index

  // Only render when visible to prevent all tabs showing at once
  if (!isVisible) {
    return null
  }

  return (
    <TabPanelContainer
      role='tabpanel'
      id={`filter-tabpanel-${categoryId}`}
      aria-labelledby={`filter-tab-${categoryId}`}
      isVisible={true}
    >
      {children}
    </TabPanelContainer>
  )
}

FilterTabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  categoryId: PropTypes.string.isRequired
}

export default FilterTabPanel
